import { Flex } from "antd";

import { useDatasetsMutatorStatus } from "@/modules/datasets/datasets-mutator";
import { useInterventionSectionContext } from "@/modules/intervention/intervention-section-context";
import { ObservationDeleteButton } from "@/modules/observation/observation-delete-button";
import ObservationInvalidationButton from "@/modules/observation/observation-invalidation-button";
import ObservationValidationButton from "@/modules/observation/observation-validation-button";
import ObservationValidationTag from "@/modules/observation/observation-validation-tag";

const InterventionSectionCardExtra = () => {
  const { isDirty, isSaving } = useDatasetsMutatorStatus();
  const {
    observation,
    isEditable,
    intervention,
    observationQuery,
    onObservationDelete,
  } = useInterventionSectionContext();

  const loading = observationQuery.isLoading;
  const disabled = isDirty || isSaving;

  const validation = observation?.validation;

  const menuQueryKey = ["interventions", "menu", intervention.id];

  return (
    <Flex gap="small">
      <ObservationValidationTag observation={observation} />
      {isEditable && observation && !validation && (
        <ObservationValidationButton
          observationId={observation.id}
          disabled={disabled}
          loading={loading}
          invalidateKeys={[menuQueryKey]}
        />
      )}
      {isEditable && validation && (
        <ObservationInvalidationButton
          observationId={observation.id}
          disabled={disabled}
          loading={loading}
          invalidateKeys={[menuQueryKey]}
        />
      )}
      {isEditable && (
        <ObservationDeleteButton
          observation={observation}
          loading={loading}
          disabled={disabled}
          onSuccess={onObservationDelete}
          invalidate={[
            { key: "list", mode: "background" },
            { queryKey: menuQueryKey, mode: "awaited" },
          ]}
        />
      )}
    </Flex>
  );
};

export default InterventionSectionCardExtra;
